import script from "./CheckPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckPage.vue?vue&type=script&setup=true&lang=js"

import "./CheckPage.vue?vue&type=style&index=0&id=42f35398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f35398"]])

export default __exports__